import { ROUTE_ACCOUNT_EDIT_COMMUNICATION_PREFERENCES } from '@/constants/routes';
import { Checkbox, Flex, Text } from '@cmpsr/components';
import EditLink from '../edit-link/edit-link';

export type CommPreferencesProps = {
  notificationsPreferences: { id: number; title: string; enabled: boolean }[];
};

export default function CommPreferences({ notificationsPreferences }: CommPreferencesProps) {
  return (
    <Flex
      flexDirection="column"
      p={{ base: 'spacer-4', md: 'spacer-6' }}
      flexGrow={1}
      width={{ base: '100%', lg: 'auto' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      backgroundColor="background-light"
      gap="spacer-4"
    >
      <Flex justifyContent="space-between">
        <Text variant="text-header-M">Communication Preferences</Text>
        <EditLink route={ROUTE_ACCOUNT_EDIT_COMMUNICATION_PREFERENCES} />
      </Flex>
      <Text variant="text-body-floating-label-regular" textTransform="uppercase">
        email notifications
      </Text>
      <Flex flexDirection="column" gap="spacer-2">
        {notificationsPreferences.map(({ title, enabled }, index) => (
          <Checkbox key={index} aria-label="Communication Preferences" size="m" isChecked={enabled} isDisabled>
            <Text variant="text-body-regular" color="text-secondary">
              {title}
            </Text>
          </Checkbox>
        ))}
      </Flex>
    </Flex>
  );
}
